import { Link, useLocation } from "react-router-dom";
import { useAuth } from "../contexts/AuthContext";

export default function FooterNav() {
  const loc = useLocation();
  const is = (p: string) => loc.pathname === p;
  const { user, logout } = useAuth();
  const loginReturnTo = encodeURIComponent(
    `${window.location.pathname}${window.location.hash || "#/"}`,
  );
  const signupReturnTo = encodeURIComponent(
    `${window.location.pathname}${window.location.hash || "#/"}`,
  );

  const doLogout = async () => {
    await logout();
    // navigate to login
    window.location.hash = "#/login";
  };

  return (
    <nav className="footer-nav">
      <Link to="/" style={{ opacity: is("/") ? 1 : 0.7 }}>
        TOP
      </Link>
      <Link to="/calendar" style={{ opacity: is("/calendar") ? 1 : 0.7 }}>
        カレンダー
      </Link>
      {user ? (
        <>
          <Link
            to="/mypage"
            style={{ opacity: is("/me") || is("/mypage") ? 1 : 0.7 }}
          >
            マイページ
          </Link>
          <a onClick={doLogout} style={{ opacity: 1, cursor: "pointer" }}>
            ログアウト
          </a>
        </>
      ) : (
        <>
          <Link
            to={`/login?returnTo=${loginReturnTo}`}
            style={{ opacity: is("/login") ? 1 : 0.7 }}
          >
            ログイン
          </Link>
          <Link
            to={`/signup?returnTo=${signupReturnTo}`}
            style={{ opacity: is("/signup") ? 1 : 0.7 }}
          >
            新規登録
          </Link>
        </>
      )}
      {/* <Link to="/users" style={{opacity:is('/users')?1:.7}}>ユーザー</Link> */}
    </nav>
  );
}
